import { Common } from './constants';
import { store } from 'store';
import _ from 'lodash';
import { t } from 'i18next';
// Parse the time to string
export const parseTime = (time?: object | string | number, cFormat?: string): string | null => {
    if (time === undefined || time === '') {
        return null;
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date: Date;
    if (typeof time === 'object') {
        date = time as Date;
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time);
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj: { [key: string]: number } = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const timeStr = format.replace(/{([ymdhisa])+}/g, (_result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value];
        }
        return value.toString().padStart(2, '0');
    });
    return timeStr;
};

// Format and filter json data using filterKeys array
export const formatJson = (filterKeys: any, jsonData: any) =>
    jsonData.map((data: any) =>
        filterKeys.map((key: string) => {
            if (key === 'timestamp') {
                return parseTime(data[key]);
            } else {
                return data[key];
            }
        }),
    );

// Check if an element has a class
export const hasClass = (ele: HTMLElement, className: string) => {
    return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

// Add class to element
export const addClass = (ele: HTMLElement, className: string) => {
    if (!hasClass(ele, className)) ele.className += ' ' + className;
};

// Remove class from element
export const removeClass = (ele: HTMLElement, className: string) => {
    if (hasClass(ele, className)) {
        const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        ele.className = ele.className.replace(reg, ' ');
    }
};

// Toggle class for the selected element
export const toggleClass = (ele: HTMLElement, className: string) => {
    if (!ele || !className) {
        return;
    }
    let classString = ele.className;
    const nameIndex = classString.indexOf(className);
    if (nameIndex === -1) {
        classString += '' + className;
    } else {
        classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
    }
    ele.className = classString;
};

export const ConvertToTableFilter = (sortName: string | number | symbol, sortOrder: 'asc' | 'desc') => {
    return `${sortName.toString()}${sortOrder === 'asc' ? '+' : '-'}`;
};
export const trimString = (value: string) => {
    return value.toString().trim();
};

export const ValidateImageDimensions = (image: any, width: number, height: number): Promise<boolean> => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const img = new Image();
            img.src = reader.result.toString();
            img.onload = (e: any) => {
                if (e.target.width === width && e.target.height === height) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
        };
        reader.readAsDataURL(image);
    });
};

export const copyText = (TextToCopy) => {
    var TempText = document.createElement('input');
    TempText.value = TextToCopy;
    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand('copy');
    document.body.removeChild(TempText);
};

export const validateLetterContent = (content: string): string[] => {
    const dynamicFields = content.match(Common.RegularExpression.DriverDebtLetterDynamicFieldsRegex);
    const notSupporteddynamicFields: string[] = [];
    if (dynamicFields && dynamicFields.length) {
        for (let i = 0; i < dynamicFields.length; i += 1) {
            if (Common.DriverDebtLetterDynamicFields.indexOf(dynamicFields[i]) < 0) {
                notSupporteddynamicFields.push(dynamicFields[i]);
            }
        }
    }
    return notSupporteddynamicFields;
};

export const regionDateAndTime = () => {
    if (!_.isEmpty(store?.getState()?.configuration?.date_time_format)) {
        return store.getState().configuration.date_time_format;
    } else {
        return {
            GENERAL_DATE_FORMAT: 'DD/MM/YYYY',
            GENERAL_DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm',
            DATE_TIME_FORMAT_WITH_SECONDS: 'DD/MM/YYYY HH:mm:ss',
            GENERAL_EXPORT_DATE_FORMAT: 'DD/MM/YYYY',
            GENERAL_EXPORT_DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
        };
    }
};

export const locale = () => {
    const days = [
        t('week.sun'),
        t('week.mon'),
        t('week.tue'),
        t('week.wed'),
        t('week.thu'),
        t('week.fri'),
        t('week.sat'),
    ];
    const months = [
        t('month.jan'),
        t('month.feb'),
        t('month.mar'),
        t('month.apr'),
        t('month.may'),
        t('month.jun'),
        t('month.jul'),
        t('month.aug'),
        t('month.sep'),
        t('month.oct'),
        t('month.nov'),
        t('month.dec'),
    ];
    return {
        localize: {
            day: (n) => days[n],
            month: (n) => months[n],
            ordinalNumber: () => {},
        },
        formatLong: {
            date: () => regionDateAndTime().GENERAL_DATE_FORMAT.toLocaleLowerCase(),
        },
    };
};

export const companyNameReplace = (fullString: string) => {
    const changeValue = store?.getState()?.configuration?.company_name || 'Instavolt';
    const originalString = fullString;
    const replacedString = originalString.replace(/##COMPANY_BRAND_NAME##/g, changeValue);
    return replacedString;
};

/**
 * Splits a string into an array of trimmed substrings using the specified separator.
 * Empty substrings (after trimming) are filtered out.
 *
 * @param {string} str - The input string to be split.
 * @param {string} separator - The character or string used to split the input string.
 * @returns {string[]} An array of non-empty, trimmed substrings.
 *
 * @example
 * splitString("a, b,  , c", ",");
 * // Returns: ["a", "b", "c"]
 */
export function splitString(str: string, separator: string): string[] {
    return str
        .split(separator)
        .map((item) => item.trim())
        .filter((item) => item !== '');
}

/**
 * Joins an array of strings into a single string using the specified separator.
 * Each string is trimmed before joining.
 *
 * @param {string[]} arr - The array of strings to be joined.
 * @param {string} separator - The character or string used to join the array elements.
 * @returns {string} A single string with trimmed elements joined by the separator.
 *
 * @example
 * joinArray(["a", " b ", "c "], ",");
 * // Returns: "a,b,c"
 */
export function joinArray(arr: string[], separator: string): string {
    return arr.map((item) => item.trim()).join(separator);
}
